import React, { Component } from 'react';
import { Grid, Button } from 'semantic-ui-react';

import { Commons } from 'components';

const propTypes = {
};

const defaultProps = {
};

class SearchForm extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    const { fn, data } = this.props;

    return(

      <Grid columns="equal">
        <Grid.Row>
          <Grid.Column width={2}>
            <span>{ data.staffCheckedData.length + "명 / " + data.userTotal + "명" }</span>
          </Grid.Column>
          <Grid.Column width={3}>
            <Commons.SikdaeGroup />
          </Grid.Column>
          <Grid.Column width={3}>
            <Commons.Authority />
          </Grid.Column>
          <Grid.Column width={3}>
            <Commons.SearchInputBox
            handleEntSubmit={fn.handleEntSubmit}
            placeHolder={"ID, 이름, 사원번호"}/>
          </Grid.Column>
          <Grid.Column className='form-right select-btn'>
            <Button
              className="search-btn"
              color='black'
              inverted
              content='조회'
              onClick={fn.search}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="division-form">
          <Commons.Division />
        </Grid.Row>
      </Grid>

    );
  }
}

SearchForm.propTypes = propTypes;
SearchForm.defaultProps = defaultProps;

export default SearchForm;
